module.exports = __webpack_public_path__ + "img/check.bd1cd04d.svg";